import script from "./Teams.vue?vue&type=script&setup=true&lang=js"
export * from "./Teams.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Teams.vue?vue&type=style&index=1&id=1f7f31cf&lang=css"

const __exports__ = script;

export default __exports__